import { c as _c } from "react/compiler-runtime";
import { Alert, BodyLong, Heading } from "@navikt/ds-react";
interface Props {
  className?: string;
}
export default function NarDuFerdigstillerPlanenAlert(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Heading level="3" size="small" spacing={true}>Når du ferdigstiller planen</Heading>;
    t2 = <BodyLong>Når du velger å ferdigstille planen deles den med den ansatte. Arbeidstakeren finner planen ved å logge seg på nav.no. Du som arbeidsgiver vil også finne planen under Oppfølgingsplaner på nav.no. Hvis du ikke er klar til å dele planen med den ansatte enda, så kan du avslutte og fortsette senere. Det du har skrevet finner du igjen i et utkast under oppfølgingsplaner for den ansatte.</BodyLong>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <Alert variant="info" className={className}>{t1}{t2}</Alert>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}